// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__kvQpa","left":"Virtual_left__iVi50","wrapper":"Virtual_wrapper__6zM-f","products":"Virtual_products__UfJeI","menu":"Virtual_menu__n2vud"};